<section class="company-setup">
  <div style="width: 95%; margin: 0 auto; position: absolute; top: 5px; left: 40px;" class="pb-2 pl-3">
    <img src="assets/modules/dummy-assets/common/img/GovEVA.png" alt="DigiCompany">
  </div>
  <div class="inner-wrap">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center">
        
        <h4 class="modal-title cat__core__title" id="myModalLabel">Setup Company</h4>

        <button class="btn btn-primary back-btn" (click)="back()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
      <form [formGroup]="companyMasterForm" class="well">
        <div class="modal-body watermark" style="min-height: 300px;">
          <!-- Company Logo, API URL and Symbol Block -->
          <div class="form-block-row">
            <div class="row">
              <div class="col-md-4 form-block-cell">
                <label class="form-block-label">Company Logo</label>
                <div class="form-block-input" style="justify-content: flex-start; padding: 10px; flex-direction: column; align-items: flex-start;">
                  <div>
                    <a class="img-circle img-responsive" id="companyLogoImg" (click)="showUploadImagePopUp()">
                      <img id="companyLogo" alt="" class="img-circle img-responsive" src="../../assets/modules/dummy-assets/common/img/avatars/Company-default.png"
                        alt="Company Logo" title="Change Company Logo">
                    </a>
                  </div>
                  <div style="display: flex; align-items: center; gap: 10px; margin-top: 10px; width: 100%;">
                    <a id="companyLogoImgChange" (click)="showUploadImagePopUp()" style="display: inline-block; text-decoration: none;">
                      <span>Change</span>
                    </a>
                    <a class="remove" (click)="removeLogoImage()" style="display: inline-block;">
                      <span>Remove</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-md-8 form-block-cell">
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-block-label">API URL
                      <span style="color: red;">*</span>
                    </label>
                    <div class="form-block-input">
                      <input class="form-control" type="url" placeholder="URL" name="url" readonly
                        [formControl]="companyMasterForm.controls['complianceEngineURL']" style="background-color: #e9ecef; cursor: not-allowed;">
                      <div
                        *ngIf="companyMasterForm.controls['complianceEngineURL'].hasError('required') && companyMasterForm.controls['complianceEngineURL'].touched"
                        class="form-control-error-custom">
                        Compliance URL is required.
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" style="margin-top: 20px;">
                    <label class="form-block-label">SYMBOL</label>
                    <div class="form-block-input">
                      <input class="form-control" type="text" placeholder="Symbol" name="symbol"
                        [formControl]="companyMasterForm.controls['symbol']">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Company Name, Registration ID Type, Registration Number, ISIN Block -->
          <div class="form-block-row">
            <div class="row">
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Company Name <span style="color: red;">*</span>
                  <span style="font-style: italic;font-size: 12px; text-transform: none; display: block; margin-top: 5px;">As registered with ROC</span>
                </label>
                <div class="form-block-input">
                  <div style="width: 100%;">
                    <div class="form-group ddl-custom" *ngIf="isCompanySetupWithoutMaster" style="margin-bottom: 0;">
                      <input id="typeahead-template" type="text" class="form-control" formControlName="companyName" />
                      <span *ngIf="searching">searching...</span>
                      <input class="form-control" type="hidden" name="companyName" [formControl]="companyMasterForm.controls['companyName']">
                      <div *ngIf="companyMasterForm.controls['companyName'].hasError('required') && companyMasterForm.controls['companyName'].touched"
                        class="form-control-error-custom">
                        Company name is required.
                      </div>
                      <div *ngIf="companyMasterForm.controls['companyName'].hasError('maxlength') && companyMasterForm.controls['companyName'].touched"
                        class="form-control-error-custom">
                        Company name should be maximum 100 character.
                      </div>
                    </div>
                    <div class="form-group ddl-custom" *ngIf="!isCompanySetupWithoutMaster" style="margin-bottom: 0;">
                      <input id="typeahead-template" type="text" class="form-control" formControlName="companyName"
                        (selectItem)="selectedItem($event)"
                        (focusout)="setPrivateEnteredCompanyName()" />
                      <span *ngIf="searching">searching...</span>
                      <input class="form-control" type="hidden" name="companyName"
                        [formControl]="companyMasterForm.controls['companyName']">
                      <div
                        *ngIf="companyMasterForm.controls['companyName'].hasError('required') && companyMasterForm.controls['companyName'].touched"
                        class="form-control-error-custom">
                        Company name is required.
                      </div>
                      <div
                        *ngIf="companyMasterForm.controls['companyName'].hasError('maxlength') && companyMasterForm.controls['companyName'].touched"
                        class="form-control-error-custom">
                        Company name should be maximum 100 character.
                      </div>
                    </div>
                    <div class="form-group" style="margin-top: 10px;">
                      <button id="btnCheckMapping" type="button" class="btn btn-sm btn-primary" 
                        (click)="checkMapping()">Check Mapping
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Registration ID Type <span style="color: red;">*</span></label>
                <div class="form-block-input">
                  <select [formControl]="companyMasterForm.controls['registrationIDType']" class="form-control"
                    (change)="onSelectRegistrationId()" style="padding:8px 20px;">
                    <option value="" style="color:#bebecd;">Select</option>
                    <option *ngFor="let registrationIDType of registrationIDTypes" value="{{registrationIDType}}">
                      {{registrationIDType}}</option>
                  </select>
                  <div
                    *ngIf="companyMasterForm.controls['registrationIDType'].hasError('required') && companyMasterForm.controls['registrationIDType'].touched"
                    class="form-control-error-custom">
                    Registration ID Type is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Registration Number <span style="color: red;">*</span></label>
                <div class="form-block-input">
                  <div style="width: 100%;">
                    <div class="form-group" *ngIf="isCompanySetupWithoutMaster" style="margin-bottom: 0;">
                      <input [formControl]="companyMasterForm.controls['registrationNumber']" class="form-control"
                        placeholder="Registration Number"
                        (focusout)="checkForCINForCompanyWithoutMaster(companyMasterForm.controls['registrationNumber'].value)">
                      <div
                        *ngIf="companyMasterForm.controls['registrationNumber'].hasError('required') && companyMasterForm.controls['registrationNumber'].touched"
                        class="form-control-error-custom">
                        Registration number is required.
                      </div>
                      <div
                        *ngIf="companyMasterForm.controls['registrationNumber'].hasError('pattern') && companyMasterForm.controls['registrationNumber'].touched"
                        class="form-control-error-custom">
                        Registration number should not be allowed special characters.
                      </div>
                      <div
                        *ngIf="!errorUniqueCINForCompany && !errorValidCINForCompany && !companyMasterForm.controls['registrationNumber'].hasError('pattern') && companyMasterForm.controls['registrationNumber'].hasError('maxlength') && companyMasterForm.controls['registrationNumber'].touched"
                        class="form-control-error-custom">
                        {{companyMasterForm.controls['registrationIDType'].value == "FCRN" && companyMasterForm.controls['registrationNumber'].hasError('maxlength')  ? "Registration number should be 6 digit ": "Registration number should be 21 digit"}}
                      </div>
                      <div
                        *ngIf="!errorUniqueCINForCompany && !errorValidCINForCompany && !companyMasterForm.controls['registrationNumber'].hasError('pattern') && companyMasterForm.controls['registrationNumber'].hasError('minlength') && companyMasterForm.controls['registrationNumber'].touched"
                        class="form-control-error-custom">
                        {{companyMasterForm.controls['registrationIDType'].value == "FCRN" && companyMasterForm.controls['registrationNumber'].hasError('minlength') ? "Registration number should be 6 digit ": "Registration number should be 21 digit"}}
                      </div>
                      <div *ngIf="errorUniqueCINForCompany&&!errorValidCINForCompany" class="form-control-error-custom">
                        Please enter unique Registration number for CIN.
                      </div>
                      <div
                        *ngIf="errorValidCINForCompany&&!companyMasterForm.controls['registrationNumber'].hasError('required')"
                        class="form-control-error-custom">
                        Please enter valid Registration number for CIN.
                      </div>
                    </div>
                    <div class="form-group" *ngIf="!isCompanySetupWithoutMaster" style="margin-bottom: 0;">
                      <input [formControl]="companyMasterForm.controls['registrationNumber']" class="form-control"
                        placeholder="Registration Number" (keydown)="restrictCIN($event)"
                        (keyup)="getCompanyByCIN()"
                        (focusout)="checkForRepeatCINForCompany(companyMasterForm.controls['registrationNumber'].value)">
                      <div
                        *ngIf="companyMasterForm.controls['registrationNumber'].hasError('required') && companyMasterForm.controls['registrationNumber'].touched"
                        class="form-control-error-custom">
                        Registration number is required.
                      </div>
                      <div
                        *ngIf="companyMasterForm.controls['registrationNumber'].hasError('pattern') && companyMasterForm.controls['registrationNumber'].touched"
                        class="form-control-error-custom">
                        Registration number should not be allowed special characters.
                      </div>
                      <div
                        *ngIf="!errorUniqueCINForCompany && !errorValidCINForCompany && !companyMasterForm.controls['registrationNumber'].hasError('pattern') && companyMasterForm.controls['registrationNumber'].hasError('maxlength') && companyMasterForm.controls['registrationNumber'].touched"
                        class="form-control-error-custom">
                        {{companyMasterForm.controls['registrationIDType'].value == "FCRN" && companyMasterForm.controls['registrationNumber'].hasError('maxlength')  ? "Registration number should be 6 digit ": "Registration number should be 21 digit"}}
                      </div>
                      <div
                        *ngIf="!errorUniqueCINForCompany && !errorValidCINForCompany && !companyMasterForm.controls['registrationNumber'].hasError('pattern') && companyMasterForm.controls['registrationNumber'].hasError('minlength') && companyMasterForm.controls['registrationNumber'].touched"
                        class="form-control-error-custom">
                        {{companyMasterForm.controls['registrationIDType'].value == "FCRN" && companyMasterForm.controls['registrationNumber'].hasError('minlength') ? "Registration number should be 6 digit ": "Registration number should be 21 digit"}}
                      </div>
                      <div *ngIf="errorUniqueCINForCompany&&!errorValidCINForCompany" class="form-control-error-custom">
                        Please enter unique Registration number for CIN.
                      </div>
                      <div
                        *ngIf="errorValidCINForCompany&&!companyMasterForm.controls['registrationNumber'].hasError('required')"
                        class="form-control-error-custom">
                        Please enter valid Registration number for CIN.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">ISIN</label>
                <div class="form-block-input">
                  <input type="text" class="form-control" placeholder="ISIN" name="isin"
                    [formControl]="companyMasterForm.controls['ISIN']" maxlength="12">
                </div>
              </div>
            </div>
          </div>
          <!-- DigiCompany Boards, AD Subscribed, Type of Company Block -->
          <div class="form-block-row">
            <div class="row">
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Is DigiCompany Boards Subscribed</label>
                <div class="form-block-input">
                  <label class="container" style="margin: 0 auto;">
                    <input type="checkbox" [checked]="isGEMSubscribedFlag"
                      [formControl]="companyMasterForm.controls['isGEMSubscribedFlag']"
                      (change)="onGEMSubscriptionChange($event)">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-md-6 form-block-cell" *ngIf="isGEMSubscribedFlag">
                <label class="form-block-label">DigiCompany Boards API URL
                  <span style="color: red;">*</span>
                </label>
                <div class="form-block-input">
                  <input class="form-control" type="url" placeholder="https://int.digicompany.in/gem/api/" name="url" readonly
                    [formControl]="companyMasterForm.controls['GEMAccessURL']" required style="background-color: #e9ecef; cursor: not-allowed;">
                  <div
                    *ngIf="companyMasterForm.controls['GEMAccessURL'].hasError('required') && companyMasterForm.controls['GEMAccessURL'].touched"
                    class="form-control-error-custom">
                    DigiCompany Boards URL is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Is AD Subscribed</label>
                <div class="form-block-input">
                  <label class="container" style="margin: 0 auto;">
                    <input type="checkbox" [checked]="isADSubscribedFlag"
                      [formControl]="companyMasterForm.controls['isADSubscribedFlag']"
                      (change)="onADSubscriptionChange($event)">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Type of Company <span style="color: red;">*</span></label>
                <div class="form-block-input">
                  <select class="form-control" [formControl]="companyMasterForm.controls['typeOfCompany']"
                    (change)="ListedConditionCheck(companyMasterForm.controls['typeOfCompany'].value)" required style="padding:8px 20px;">
                    <option value="" style="color:#bebecd;">Select</option>
                    <option *ngFor="let typeOfCompany of typesOfCompany" value="{{typeOfCompany}}">{{typeOfCompany}}
                    </option>
                  </select>
                  <div *ngIf="companyMasterForm.controls['typeOfCompany'].hasError('required') && companyMasterForm.controls['typeOfCompany'].touched"
                    class="form-control-error-custom">
                    Type of Company is required.
                  </div>
                  <div *ngIf="companyMasterForm.controls['typeOfCompany'].hasError('maxlength') && companyMasterForm.controls['typeOfCompany'].touched"
                    class="form-control-error-custom">
                    Type of Company should be maximum 100 character.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- START AD -->
          <!-- AD Server Configuration Fields Block -->
          <div *ngFor="let server of adServerArray; let count = index; let last=last; let first= first">
            <div class="form-block-row" *ngIf="isADSubscribedFlag">
              <div class="row">
                <div class="col-lg-12 pb-2" style="padding-left: 15px; padding-right: 15px;">
                  <i class="fa fa-close btn btn-sm btn-light" style="float: right!important;"
                    (click)="removeADServerConfirguration(count)" *ngIf="!first && last"></i>
                </div>
                <div class="col-md-4 form-block-cell">
                  <label class="form-block-label">AD URL
                    <span style="color: red;">*</span>
                  </label>
                  <div class="form-block-input">
                    <input class="form-control" type="url" placeholder="Url" [name]="'ADUrl'+ count"
                      [formControl]="companyMasterForm.controls['ADUrl'+count]" required>
                    <div
                      *ngIf="companyMasterForm.controls['ADUrl'+count].hasError('required') && companyMasterForm.controls['ADUrl'+count].touched"
                      class="form-control-error-custom">
                      AD Url is required.
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-block-cell">
                  <label class="form-block-label">AD Administrator Email ID
                    <span style="color: red;">*</span>
                  </label>
                  <div class="form-block-input">
                    <input class="form-control" type="email" placeholder="Email ID" [name]="'ADEmailID' + count"
                      [formControl]="companyMasterForm.controls['ADEmailID' + count]" required>
                    <div
                      *ngIf="companyMasterForm.controls['ADEmailID' + count].hasError('required') && companyMasterForm.controls['ADEmailID' + count].touched"
                      class="form-control-error-custom">
                      AD Administrator email is required.
                    </div>
                    <div
                      *ngIf="companyMasterForm.controls['ADEmailID' + count].hasError('email') && companyMasterForm.controls['ADEmailID' + count].touched && !companyMasterForm.controls['ADEmailID' + count].hasError('required')"
                      class="form-control-error-custom">
                      Please enter valid email Id.
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-block-cell">
                  <label class="form-block-label">AD Administrator Password
                    <span style="color: red;">*</span>
                  </label>
                  <div class="form-block-input">
                    <input class="form-control" type="password" placeholder="AD Password" [name]="'ADPassword' + count"
                      [formControl]="companyMasterForm.controls['ADPassword' + count]" required>
                    <div
                      *ngIf="companyMasterForm.controls['ADPassword' + count].hasError('required') && companyMasterForm.controls['ADPassword' + count].touched"
                      class="form-control-error-custom">
                      AD Administrator password is required.
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="last">
                <div class="col-md-12" style="padding-left: 15px; padding-right: 15px; margin-top: 10px;">
                  <button class="btn btn-sm btn-primary" style="float:right; padding: 10px 20px;"  
                    (click)="addAdServerControls()">Add More Server</button>
                </div>
              </div>
            </div>
          </div>
          <!-- END AD -->
          <!-- Website URL, Category of Company, Date of Incorporation, Exchange Code Block -->
          <div class="form-block-row">
            <div class="row">
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Date of Incorporation</label>
                <div class="form-block-input">
                  <div class="input-group" (click)="$event.stopPropagation()">
                    <input class="form-control" [attr.readonly]="true" [minDate]="minDate" [maxDate]="maxDate" [formControl]="companyMasterForm.controls['dateOfIncorporation']"
                      [(ngModel)]="dateOfIncorporationModel" style="z-index: 0;background-color:white;" placeholder="dd-mm-yyyy"
                      name="dpIncorporation" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle();d.close();s.close()" (document:click)="a.close();s.close();d.close();">
                    <button class="input-group-addon" type="button" (click)="clearDateOfIncoporation()">
                      <span class="fa fa-close" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button>
                    <button class="input-group-addon" type="button" (click)="a.toggle();d.close();s.close()">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button>
                  </div>
                </div>
              </div>
           
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Category of Company <span style="color: red;">*</span></label>
                <div class="form-block-input">
                  <select class="form-control" [formControl]="companyMasterForm.controls['categoryOfCompany']"
                    name="categoryOfCompany" required style="padding:8px 20px;">
                    <option value="" style="color:#bebecd;">Select</option>
                    <option *ngFor="let categoryOfCompany of categoriesOfCompany" value="{{categoryOfCompany}}">
                      {{categoryOfCompany}}</option>
                  </select>
                  <div *ngIf="companyMasterForm.controls['categoryOfCompany'].hasError('required') && companyMasterForm.controls['categoryOfCompany'].touched"
                    class="form-control-error-custom">
                    Category of Company is required.
                  </div>
                  <div *ngIf="companyMasterForm.controls['categoryOfCompany'].hasError('maxlength') && companyMasterForm.controls['categoryOfCompany'].touched"
                    class="form-control-error-custom">
                    Category of Company should be maximum 100 character.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Website URL</label>
                <div class="form-block-input">
                  <input class="form-control" type="url" placeholder="URL" name="url"
                    [formControl]="companyMasterForm.controls['chatEngineURL']">
                </div>
              </div>
            
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Exchange Code</label>
                <div class="form-block-input">
                  <input class="form-control" placeholder="Exchange Code" name="exchangeCode"
                    [formControl]="companyMasterForm.controls['exchangeCode']">
                </div>
              </div>
            </div>
          </div>
        


          <!-- Listed Company, NBFC Regulations, Accepts Deposits, Financial Year Block -->
          <div class="form-block-row">
            <div class="row">
              <div class="col-md-6 form-block-cell" *ngIf="hideListedCompany" id="listCompanyCheck">
                <label class="form-block-label">Listed Company</label>
                <div class="form-block-input">
                  <div class="form-group" style="width: 100%;">
                    <div class="d-flex justify-content-center align-items-center">
                      <label class="form-check-label">
                        <input type="radio" [formControl]="companyMasterForm.controls['listedCompany']"
                          style="position:absolute" name="listedCompany" value=true class="form-check-input"
                          (click)="showListingTypeDiv()">Yes
                        <span class="checkmark"></span>
                      </label>
                      <label class="form-check-label">
                        <input type="radio" [formControl]="companyMasterForm.controls['listedCompany']"
                          style="position:absolute" name="listedCompany" value=false class="form-check-input"
                          (click)="hideListingTypeDiv()">No
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div *ngIf="showSelected" class="mt-3 list-comp-submenu">
                      <label class="container">
                        <input type="checkbox" [formControl]="companyMasterForm.controls['equityListing']"
                          [checked]="equityListingFlag"
                          (change)="onListingTypeChange(companyMasterForm.controls['equityListing'].value, 'equityListing')">Equity
                        Listing
                        <span class="checkmark"></span>
                      </label>
                      <label class="container">
                        <input type="checkbox" [formControl]="companyMasterForm.controls['equityListingSMESegment']"
                          [checked]="equityListingSMESegmentFlag" [(ngModel)]="equityListingSMESegmentFlag"
                          (change)="onListingTypeChange(companyMasterForm.controls['equityListingSMESegment'].value, 'equityListingSMESegment')">SME
                        Listing
                        <span class="checkmark"></span>
                      </label>
                      <label class="container">
                        <input type="checkbox" [formControl]="companyMasterForm.controls['onlyDebtListing']"
                          [checked]="onlyDebtListingFlag"
                          (change)="onListingTypeChange(companyMasterForm.controls['onlyDebtListing'].value, 'onlyDebtListing')">Only
                        Debt Listing
                        <span class="checkmark"></span>
                      </label>
                      <div>
                        <label class="container">
                          <input type="checkbox" [formControl]="companyMasterForm.controls['debtListing']"
                            [checked]="debtListingFlag"
                            (change)="onListingTypeChange(companyMasterForm.controls['debtListing'].value , 'debtListing')">Debt
                          Listing (along with other)
                          <span class="checkmark"></span>
                        </label>
                      </div>
                      <div *ngIf="!isCheckedListedCompany" class="form-control-error-custom">
                        Please select at least one Listing type
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 form-block-cell" [ngClass]="{'col-md-12': !hideListedCompany}">
                <label class="form-block-label">NBFC Regulations</label>
                <div class="form-block-input">
                  <div class="form-group" style="width: 100%;">
                    <div class="d-flex justify-content-center align-items-center">
                      <label class="form-check-label">
                        <input type="radio" [formControl]="companyMasterForm.controls['nbfcRegulations']"
                          style="position:absolute" name="nbfc" value="Yes" class="form-check-input"
                          (click)="nbfcRegulationsValueTrue()">Yes
                        <span class="checkmark"></span>
                      </label>
                      <label class="form-check-label">
                        <input type="radio" [formControl]="companyMasterForm.controls['nbfcRegulations']"
                          style="position:absolute" name="nbfc" value="No" class="form-check-input"
                          (click)="nbfcRegulationsValueFalse()">No
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Accepts Deposits</label>
                <div class="form-block-input">
                  <div class="form-group" style="width: 100%;">
                    <div class="d-flex justify-content-center align-items-center">
                      <label class="form-check-label">
                        <input type="radio" [formControl]="companyMasterForm.controls['acceptsDeposits']"
                          style="position:absolute" name="acceptdeposits" value=true class="form-check-input"
                          (click)="acceptDepositValueTrue()">Yes
                        <span class="checkmark"></span>
                      </label>
                      <label class="form-check-label">
                        <input type="radio" [formControl]="companyMasterForm.controls['acceptsDeposits']"
                          style="position:absolute" name="acceptdeposits" value=false class="form-check-input"
                          (click)="acceptDepositValueFalse()">No
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="acceptsDeposits">
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Asset Size <span style="color: red;">*</span></label>
                <div class="form-block-input">
                  <input type="number" [formControl]="companyMasterForm.controls['amountoFDeposits']"
                    class="form-control" placeholder="Asset Size" required>
                  <div
                    *ngIf=" companyMasterForm.controls['amountoFDeposits'].hasError('required') && companyMasterForm.controls['amountoFDeposits'].touched"
                    class="form-control-error-custom">
                    Asset Size is required.
                  </div>
                  <div
                    *ngIf=" companyMasterForm.controls['amountoFDeposits'].hasError('min') && companyMasterForm.controls['amountoFDeposits'].touched"
                    class="form-control-error-custom">
                    Please enter amount greater than 0.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Number of Shareholders, Debenture-Holders, Deposit-Holders, Security-Holders Block -->
          <div class="form-block-row">
            <div class="row">
              <div class="col-md-3 form-block-cell">
                <label class="form-block-label">Number of Shareholders</label>
                <div class="form-block-input">
                  <input type="number" [formControl]="companyMasterForm.controls['noOfShareholders']"
                    class="form-control" (keydown)="onlyNumber($event)" maxlength="11">
                </div>
              </div>
              <div class="col-md-3 form-block-cell">
                <label class="form-block-label">Number of Debenture-Holders</label>
                <div class="form-block-input">
                  <input type="number" [formControl]="companyMasterForm.controls['noOfDebentureHolders']"
                    class="form-control" (keydown)="onlyNumber($event)" maxlength="11">
                </div>
              </div>
              <div class="col-md-3 form-block-cell">
                <label class="form-block-label">Number of Deposit-Holders</label>
                <div class="form-block-input">
                  <input type="number" [formControl]="companyMasterForm.controls['noOfDepositHolders']"
                    class="form-control" (keydown)="onlyNumber($event)" maxlength="11">
                </div>
              </div>
              <div class="col-md-3 form-block-cell">
                <label class="form-block-label">Number of Security-Holders</label>
                <div class="form-block-input">
                  <input type="number" [formControl]="companyMasterForm.controls['noOfSecurityHolders']"
                    class="form-control" (keydown)="onlyNumber($event)" maxlength="11">
                </div>
              </div>
            </div>
          </div>

           <!-- Registered Office Address and Financial Year Block -->
           <div class="form-block-row">
            <div class="row">
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Registered Office Address</label>
                <div class="form-block-input">
                  <textarea [formControl]="companyMasterForm.controls['registeredOfficeAddress']"
                    class="form-control" rows="3" style="min-height: 130px;"></textarea>
                  <div
                    *ngIf="companyMasterForm.controls['registeredOfficeAddress'].hasError('minlength') && companyMasterForm.controls['registeredOfficeAddress'].touched"
                    class="form-control-error-custom">
                    Registered Office Address should be minimum 10 character.
                  </div>
                  <div
                    *ngIf="companyMasterForm.controls['registeredOfficeAddress'].hasError('maxlength') && companyMasterForm.controls['registeredOfficeAddress'].touched"
                    class="form-control-error-custom">
                    Registered Office Address should be maximum 500 character.
                  </div>
                </div>
              </div>
              <div class="col-md-6 form-block-cell financial-year-cell">
                <label class="form-block-label">Financial Year</label>
                <div class="form-block-input">
                  <div class="form-group financial-year-datepicker-container" style="width: 100%; position: relative;">
                    <div class="input-group datepicker-wrapper" (click)="$event.stopPropagation()" style="width:100%; margin-bottom: 10px; position: relative;">
                      <span style="padding: 8px 10px 0 0;">From</span>
                      <input class="form-control" [attr.readonly]="true" [formControl]="companyMasterForm.controls['FinancialYearFrom']"
                        [(ngModel)]="financialYearFromModel" placeholder="dd-mm-yyyy"
                        name="dpFinancialYearFrom" ngbDatepicker #d="ngbDatepicker" (click)="d.toggle();a.close();s.close()" (document:click)="a.close();s.close();d.close();"
                        style="position: relative; z-index: 1;">
                      <button class="input-group-addon" (click)="clearFinancialYearFrom()" type="button">
                        <span class="fa fa-close" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                      <button class="input-group-addon" (click)="d.toggle();a.close();s.close()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                    <div class="input-group datepicker-wrapper" (click)="$event.stopPropagation()" style="width:100%; position: relative;">
                      <span style="padding: 8px 10px;">To</span>
                      <input class="form-control" [attr.readonly]="true" [formControl]="companyMasterForm.controls['FinancialYearTo']"
                        [(ngModel)]="financialYearToModel" placeholder="dd-mm-yyyy"
                        name="dpFinancialYearTo" ngbDatepicker #s="ngbDatepicker" (click)="s.toggle();a.close();d.close()" (document:click)="a.close();s.close();d.close();"
                        style="position: relative; z-index: 1;">
                      <button class="input-group-addon" (click)="clearFinancialYearTo()" type="button">
                        <span class="fa fa-close" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                      <button class="input-group-addon" (click)="s.toggle();a.close();d.close()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                    <div *ngIf="error.isError" style="color: #fb434a;font-size: 80%;z-index: 1; margin-top: 5px;">
                      {{ error.errorMessage }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label">Type of Industry</label>
                <div class="form-block-input">
                  <select (change)="selectIndustry($event)"
                    [formControl]="companyMasterForm.controls['typeOfIndustry']" class="form-control" style="padding:8px 20px;">
                    <option value="" style="color:#bebecd;">Select</option>
                    <option *ngFor="let typeOfIndustry of industryTypes" value="{{typeOfIndustry.IND_CODE}}">
                      {{typeOfIndustry.INDUSTRY}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 form-block-cell">
                <label class="form-block-label custom-tooltip">
                  Peer Companies
                  <span class="custom-tooltiptext">
                    Define companies against which you want to do Peer Analysis for Ratios
                  </span>
                </label>
                <div class="form-block-input">
                  <ng-select id=peersdropdown [items]="peersList" [ngModel]="chosenPeers"
                    [formControl]="companyMasterForm.controls['peersName']" [multiple]="true"
                    (selected)="getSelectedPeers($event)" (deselected)="multiplePeersDeselected($event)">
                  </ng-select>
                  <div *ngIf="invalidPeers" class="form-control-error-custom">
                    Maximum 5 Peer companies can be selected.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Subsidiary Company Information Block -->
          <div class="form-block-row">
            <div class="row">
              <div class="col-lg-12">
                <b>Subsidiary Company Information (This will be a table to be filled by CS of Company)</b>
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th width="320">Name Of Subsidiary Company</th>
                    <th width="230">CIN/Other</th>
                    <th width="420">Type</th>
                    <th width="20">Shareholding</th>
                    <th width="100">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let subsidiary of subsidiaryArray; let indexCount = index">
                    <td>
                      <div *ngIf="!subsidiary.isEdit">
                        {{subsidiary.Name}}
                      </div>
                      <div *ngIf="subsidiary.isEdit" class="ddl-custom">
                            <input type="text" class="form-control"
                              [ngModel]="getSubsidiaryName(subsidiary)" (ngModelChange)="updateSubsidiaryName($event, subsidiary)"
                              formControlName="exSubsidiaryName" [ngbTypeahead]="searchSubsidiaryCompany"
                              (selectItem)="getExistingSubsidiarySelected($event, subsidiary)" />
                          </div>

                          <div *ngIf="subsidiary.isEdit && subsidiary.isFoundOtherSubsidery">
                            <input class="form-control" value="{{subsidiary.otherSubsideryName}}"
                              [(ngModel)]='subsidiary.otherSubsideryName' type="text"
                              (focusout)="onLeaveEventOfExistingOtherSubsidery($event,subsidiary)" />
                          </div>
                    </td>
                    <td>
                          <div *ngIf="!subsidiary.isEdit">
                            {{subsidiary.CIN}}
                          </div>
                          <div *ngIf="subsidiary.isEdit">
                            <input class="form-control" type="text" maxlength="21"
                              [formControl]="companyMasterForm.controls['exSubsidiaryCIN']" value="{{subsidiary.CIN}}"
                              [(ngModel)]='subsidiary.dirtyCIN'
                              (focusout)="checkForRepeatCINForExistingSubsidery(subsidiary)" />
                            <div *ngIf="!subsidiary.isValidCIN" class="form-control-error-custom">
                              Please enter valid CIN of 21 characters.
                            </div>

                            <div *ngIf="!subsidiary.isUniqueCIN && subsidiary.isValidCIN"
                              class="form-control-error-custom">
                              Please enter unique CIN of 21 characters.
                            </div>

                          </div>
                    </td>
                    <td>
                      <div *ngIf="!subsidiary.isEdit">
                            {{subsidiary.Type}}
                      </div>
                      <div *ngIf="subsidiary.isEdit">
                            <select class="form-control" type="text"
                              [formControl]="companyMasterForm.controls['exSubsidiaryType']"
                              value="{{subsidiary.Type}}" [(ngModel)]='subsidiary.dirtySubsideryType'>
                              <option value="" style="color:#bebecd;">Select</option>
                              <option *ngFor="let typeOfCompany of typesOfCompany" value="{{typeOfCompany}}">
                                {{typeOfCompany}}</option>
                            </select>
                      </div>
                    </td>
                    <td>
                      <div *ngIf="!subsidiary.isEdit">
                            {{subsidiary.Shareholding + " % "}}
                      </div>
                      <div *ngIf="subsidiary.isEdit">
                            <input class="form-control" type="number" min="1" max="100" maxlength = "3"
                              [formControl]="companyMasterForm.controls['exSubsidiaryShareholding']"
                              value="{{subsidiary.Shareholding}}" [(ngModel)]='subsidiary.dirtyShareholding'
                              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" />
                      </div>
                    </td>
                        <td>
                          <div *ngIf="subsidiary.isEdit">
                            <button class="btn btn-sm btn-primary"
                              [disabled]="((!subsidiary.isValidExSubsideryName) ||  !subsidiary.isValidCIN || subsidiary.dirtySubsideryType=='' || subsidiary.dirtyShareholding==null || errorUniqueCIN || !(subsidiary.dirtyShareholding > 0 && subsidiary.dirtyShareholding <= 100 ))"
                              type="button" (click)="updateSubsidiaryData(subsidiary)">
                              <i class="fa fa-plus pr-2"></i>Update</button>
                            <button class="btn btn-sm btn-primary" type="button"
                              (click)="cancelDirtySelection(subsidiary)">Cancel</button>
                          </div>
                          <div *ngIf="!subsidiary.isEdit">
                            <button class="btn btn-sm btn-primary" type="button"
                              (click)="selectSubsiderydata(subsidiary);">Edit</button>
                            <button class="btn btn-sm btn-danger" type="button"
                              (click)="deleteSubsidiaryData(indexCount)">Delete</button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="ddl-custom" *ngIf="isCompanySetupWithoutMaster">
                          <input type="text" class="form-control" formControlName="newSubsidiaryCompanyName" />
                          <input class="form-control" [(ngModel)]="otherSubsideryName"
                            [formControl]="companyMasterForm.controls['otherSubsidiaryCompanyName']" type="text"
                            id="newSubsidiaryName" name="newSubsidiaryName" style="display:none"
                            (focusout)="onLeaveEventOfOtherSubsideryName()" />
                          <div *ngIf="companyMasterForm.controls['newSubsidiaryCompanyName'].hasError('maxlength')"
                            class="form-control-error-custom">
                            Name should be less than 100 characters.
                          </div>

                        </td>
                        <td class="ddl-custom" *ngIf="!isCompanySetupWithoutMaster">
                          <input type="text" class="form-control" formControlName="newSubsidiaryCompanyName"
                            [ngbTypeahead]="searchSubsidiaryCompany"
                            (selectItem)="selectedSubsidiaryCompanyItem($event)" />
                          <input class="form-control" [(ngModel)]="otherSubsideryName"
                            [formControl]="companyMasterForm.controls['otherSubsidiaryCompanyName']" type="text"
                            id="newSubsidiaryName" name="newSubsidiaryName" style="display:none"
                            (focusout)="onLeaveEventOfOtherSubsideryName()" />
                          <div *ngIf="companyMasterForm.controls['newSubsidiaryCompanyName'].hasError('maxlength')"
                            class="form-control-error-custom">
                            Name should be less than 100 characters.
                          </div>

                        </td>
                        <td>
                          <input class="form-control" [formControl]="companyMasterForm.controls['newSubsidiaryCIN']"
                            type="text" id="newSubsidiaryCIN" name="newSubsidiaryCIN" maxlength="21"
                            (focusout)="checkForRepeatCIN(companyMasterForm.controls['newSubsidiaryCIN'].value)" />
                          <div
                            *ngIf=" companyMasterForm.controls['newSubsidiaryCIN'].touched &&  companyMasterForm.controls['newSubsidiaryCIN'].hasError('maxlength') && !errorUniqueCIN"
                            class="form-control-error-custom">
                            Please enter CIN number of 21 characters.
                          </div>
                          <div *ngIf="errorUniqueCIN" class="form-control-error-custom">
                            Please enter Unique CIN of 21 characters.
                          </div>
                          <div
                            *ngIf="companyMasterForm.controls['newSubsidiaryCIN'].touched && !companyMasterForm.controls['newSubsidiaryCIN'].hasError('minlength') && !companyMasterForm.controls['newSubsidiaryCIN'].hasError('maxlength') &&  companyMasterForm.controls['newSubsidiaryCIN'].hasError('pattern') && !errorUniqueCIN"
                            class="form-control-error-custom">
                            Please enter valid CIN of 21 characters.
                          </div>
                        </td>
                        <td>
                          <select class="form-control" [formControl]="companyMasterForm.controls['newSubsidiaryType']"
                            type="text" id="newSubsidiaryType" name="newSubsidiaryType">
                            <option value="" style="color:#bebecd;">Select</option>
                            <option *ngFor="let typeOfCompany of typesOfCompany" value="{{typeOfCompany}}">
                              {{typeOfCompany}}</option>
                          </select>
                          <div
                            *ngIf=" companyMasterForm.controls['newSubsidiaryType'].touched && companyMasterForm.controls['newSubsidiaryType'].value== ''"
                            class="form-control-error-custom">
                            Please select company type.
                          </div>
                        </td>
                        <td>
                          <input class="form-control" type="number" min="1" max="100" maxlength = "3"
                            [formControl]="companyMasterForm.controls['newSubsidiaryShareholding']"
                            id="newSubsidiaryShareholding" name="newSubsidiaryShareholding" 
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" 
                             />
                          <div *ngIf=" companyMasterForm.controls['newSubsidiaryShareholding'].hasError('max')"
                            class="form-control-error-custom">
                            Please enter valid percentage upto 100.
                          </div>
                          <div *ngIf=" companyMasterForm.controls['newSubsidiaryShareholding'].hasError('min')"
                            class="form-control-error-custom">
                            Please enter value greater than 0.
                          </div>
                        </td>
                        <td>
                          <button class="btn btn-sm btn-primary" type="button"
                            [disabled]="!( (companyMasterForm.controls['newSubsidiaryCompanyName'].value!='' && isValidSubsdieryName  && companyMasterForm.controls['newSubsidiaryCompanyName'].valid) && (companyMasterForm.controls['newSubsidiaryCIN'].valid)  && (companyMasterForm.controls['newSubsidiaryType'].value!='' && companyMasterForm.controls['newSubsidiaryType'].valid) && (companyMasterForm.controls['newSubsidiaryShareholding'].value!='' && companyMasterForm.controls['newSubsidiaryShareholding'].valid) && !(errorUniqueCIN))"
                            (click)="addSubsidiaryData()">
                            <i class="fa fa-plus pr-2"></i>Add</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div style="width:100%; text-align: left;">
              <span style="color: #ff0000">*</span> Indicates Mandatory field
            </div>

            <button id="btnsaveCompany" type="button" class="btn btn-sm btn-primary"
              [disabled]="((!companyMasterForm.valid) || (errorUniqueCINForCompany) || invalidPeers || errorValidCINForCompany)"
              (click)="addCompany()">Save</button>
            <button id="btnClearData" type="button" class="btn btn-sm btn-primary" (click)="clearData()">Clear</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal fade" id="uploadCompanyLogoPopUp" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content" style="border: 1px solid rgba(0,0,0,.2);">
        <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
          Select Company Logo
        </div>
        <div class="modal-body" style="padding: 10px 15px;">
          <label for="file">Choose File</label>
          <input #myInput type="file" id="file" (change)="handleFileInput($event.target.files)">
          <img [src]="base64Code" alt="base64Code" style="height: auto; width: 100%;">
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary btn-sm" [disabled]="isInvalidImage" (click)="setCompanyLogo()">Set as company
            logo
          </button>
          <button class="btn btn-sm" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div id="alertPopUpTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
          Title!
        </div>
        <div class="modal-body" style="padding: 10px 15px;">
          <div id="alertMessage" style="font-size: 16px;">
            Message..
          </div>
        </div>
      </div>
    </div>
  </div>
</section>